import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// Shared brand palette. `info` is kept in sync with `primary` on purpose:
// the app uses color="info" for primary actions and progress bars.
const brand = {
  primary: '#3b5bdb',
  secondary: '#5b616e',
  accent: '#3b5bdb',
  info: '#3b5bdb',
  success: '#2f9e44',
  warning: '#f08c00',
  error: '#e03131',
};

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: { ...brand },
      dark: {
        ...brand,
        primary: '#748ffc',
        accent: '#748ffc',
        info: '#748ffc',
      },
    },
  },
});
